import React from "react";
import "./Footer.css";

const Footer = (props) => {
  return (
    <div className="footerContainer">
      <div className="footerWrapper">
        <div className="footerDivs letstalk">
          <h2>Let't talk!</h2>
        </div>
        <div className="footerDivs links">
          <ul>
            <h2>Contact</h2>
            <li className="footerLink-btns">Phone: +387 62 849 895</li>
            <li className="footerLink-btns">
              <a
                rel="noreferrer noopener"
                target="_blank"
                className="link"
                href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=suljagicfaruk1@gmail.com"
              >
                Email: suljagicfaruk1@gmail.com
              </a>
            </li>
          </ul>
        </div>
        <div className="footerDivs links">
          <ul>
            <h2>Links</h2>
            <li className="footerLink-btns">
              <i className="fab fa-linkedin" />
              <a
                rel="noreferrer noopener"
                target="_blank"
                className="linkspace"
                href="https://www.linkedin.com/in/faruk-suljagic-87b14b216/"
              >
                Faruk Suljagic
              </a>
            </li>
            <li className="footerLink-btns">
              <i className="fab fa-github"></i>
              <a
                rel="noreferrer noopener"
                target="_blank"
                href="https://github.com/Faruk-Suljagic?tab=repositories"
                className="linkspace"
              >
                Faruk-Suljagic
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
